import { config } from '@/config';
import { BaseQueryApi, FetchArgs, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import axios from 'axios';

const customBaseAdminQuery = () => {
  const ADMIN_BASE_URL =
    process.env.REACT_APP_ADMIN_ENDPOINT || 'https://cms.synctrack.io/s/api/';
  const baseQuery = fetchBaseQuery({
    baseUrl: ADMIN_BASE_URL,
    credentials: 'include',
    prepareHeaders: (headers) => {
      if (config.source) {
        headers.set('authorization', `Bearer ${config.token || ''}`);
      }
      return headers;
    },
  });
  return async (args: string | FetchArgs, api: BaseQueryApi, extraOptions: {}) => {
    const response = await baseQuery(args, api, extraOptions);
    if (response.error?.status === 401) {
      try {
        await axios.get('/auth/refresh-token', {
          baseURL: "https://cms.synctrack.io/s/api",
          withCredentials: true,
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${config.token || ''}`,
            // 'X-Client-Version': '1.0.0',
            // 'Accept': 'application/json',
          },
        });
        // return retryResponse;
        // if (window.location.hostname.includes('localhost')) {
        //   setAccessToken(res.data.data.token);
        // }
        // return instance(originalConfig);
      } catch (err) {
        console.error('Refresh failed:', err);
        // removeTokens();
        // window.location.href = CMS_ROUTE.LOGIN;
      }
    }
    return response;
  };
};

export default customBaseAdminQuery;